import React from "react";
import { FieldError, UseFormRegisterReturn } from "react-hook-form";
import { FormRow } from "./FormRow";

interface TextInputProps {
  label: string;
  registration?: UseFormRegisterReturn; // Сделаем необязательным
  required?: boolean;
  error?: FieldError;
  type?: "text" | "email" | "password" | "number";
  placeholder?: string;
  value?: string;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void; // Добавим обработчик
}

export const TextInput: React.FC<TextInputProps> = ({
  label,
  registration,
  required = false,
  error,
  type = "text",
  placeholder = "",
  value,
  onChange,
}) => {
  // Если есть registration, используем его, иначе свой onChange
  const inputProps = registration 
    ? { ...registration } 
    : { 
        value,
        onChange
      };

  return (
    <FormRow label={label} required={required} error={error}>
      <input type={type} placeholder={placeholder} {...inputProps} />
    </FormRow>
  );
};